import React from "react";

export default function PaymentListSheet({
  payments,
  isCreateOpen,
  setIsCreateOpen,
}) {
  if (!payments) return null;

  const { booking, paymentMethod } = payments;
  const paymentReferences = booking?.paymentReferences || [];
  const grandTotal = booking?.paymentReferences?.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0
  ) || 0;
  const totalsByCurrency = paymentReferences.reduce((acc, ref) => {
    const currency = ref.currency || "AOA";
    const amount = Number(ref.amount) || 0;

    if (!acc[currency]) {
      acc[currency] = 0;
    }

    acc[currency] += amount;

    return acc;
  }, {});
  return (
    <>
      <div
        className={`modal-background ${isCreateOpen ? "open" : ""}`}
        onClick={() => setIsCreateOpen(false)}
      />

      <div className={`modal-overlay ${isCreateOpen ? "open" : ""}`}>
        <div className="paymentScreen">
          {/* Header */}
          <div className="headerCreateList">
            <h5 className="m-0">Payment status</h5>
            <img
              src="/assets/img/close.svg"
              alt="Close"
              onClick={() => setIsCreateOpen(false)}
            />
          </div>

          <div className="createListSection">
            <div className="commonRightTracking">
              <div className="mb-5">
                {/* ORDER INFO (shown once) */}
                <div className="initiatingOrder">
                  <h5 className="orderTitle m-0">
                    Order id : <span>#{booking?.orderId}</span>
                  </h5>

                  <p className="m-0">
                    Track the current state of payment for each booking,
                    including successful transactions, pending clearances, and
                    failed attempts.
                  </p>
                </div>

                {/* 🔁 ALL PAYMENT REFERENCES */}
                {paymentReferences.length > 0 ? (
                  paymentReferences.map((ref, index) => (
                    <div
                      key={index}
                      className="priceCalculatorSec"
                      style={{
                        borderTop: "1px solid #eee",
                        paddingTop: "15px",
                      }}
                    >
                      <div className="initiatingOrder">
                        <h5 className="orderTitle m-0">
                          Reference id : <span>{ref.referenceId}</span>
                        </h5>

                        <h5 className="orderTitle m-0">
                          Description : <span>{ref.paymentDescription}</span>
                        </h5>

                        <h5 className="orderTitle m-0">
                          Date :{" "}
                          <span>
                            {new Date(ref.createdAt).toLocaleString("en-GB")}
                          </span>
                        </h5>
                      </div>

                      <div className="priceCalculator">
                        <p className="m-0 commonFontSize">Payment method</p>
                        <p className="m-0 commonFontSize">{paymentMethod}</p>
                      </div>

                      <div className="priceCalculator">
                        <h6 className="m-0 commonFontSize">Amount</h6>
                        <h6 className="m-0 commonFontSize">
                          {ref?.currency || 'AOA'} {ref.amount}
                        </h6>
                      </div>

                      <button
                        type="button"
                        className="signInButton buttonFullWidth"
                        style={{ marginTop: "10px" }}
                      >
                        {ref.status === "completed"
                          ? "Success"
                          : ref.status === "failed"
                            ? "Failed"
                            : "Pending"}
                      </button>
                    </div>
                  ))
                ) : (
                  <p className="m-0">No payment reference found.</p>
                )}

                <div className="priceCalculatorSec">
                  {/* <div className="priceCalculator"> */}
                    {/* <h6 className="m-0 commonFontSize">Grand total</h6>
                    <h6 className="m-0 commonFontSize">
                      AOA {grandTotal.toLocaleString()}
                    </h6> */}
                    <div className="grandTotalCard">
                      <h5 className="title">Grand Total</h5>

                      {Object.entries(totalsByCurrency).map(([currency, total]) => (
                        <div key={currency} className="totalRow">
                          <span className="currency">{currency}</span>
                          <span className="amount">{total}</span>
                        </div>
                      ))}
                    </div>
                  {/* </div> */}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
